export default "__VITE_ASSET__CvHUkBEd__"